import { ReportTextField } from './ReportTextField';
import React, { useEffect, useState } from 'react';
import helpers from '../../../utils/helpers';
import { useFormikContext } from 'formik';

export const ReportDocumentField = ({name, label="CPF ou CNPJ do proprietario", ...rest}) => {
  const [formattedDoc, setFormattedDoc] = useState('')
  const [rawDoc, setRawDoc] = useState('')

  const { setFieldValue } = useFormikContext();


  useEffect(()=> {
    setFieldValue(name, helpers.somenteAlfanumericos(rawDoc))
  },[name, rawDoc, setFieldValue])

  const handleChangeDocumentoProprietario = (v) => {
    setRawDoc(v)
    setFormattedDoc(helpers.formatarDocumento(v))
  }

  return (
    <ReportTextField
      name="nuDocumentoProprietario"
      label={label}
      {...rest}
      value={formattedDoc || ''}
      onChange={e => handleChangeDocumentoProprietario(e.target.value)}
    />
  );
}
